import { FC, ReactNode } from 'react';
import { WizardSidebarSx } from './types';

export interface WizardSidebarProps {
    children: ReactNode;
    className?: string;
    sx?: WizardSidebarSx;
}

const WizardSidebar: FC<WizardSidebarProps> = ({ className, sx, children }) => {
    return (
        <div
            className={`w-2/12 flex flex-col font-sf p-6 bg-sf-white border border-sf-gray-100 rounded-2xl ${className}`}
            style={sx?.root}>
            {children}
        </div>
    );
};

export default WizardSidebar;
